<template>
 <main class="html-page home-page gallery-page">
<main><section class="page-hero gallery-hero" data-bloco="galeria-hero" data-tipo="hero"><div class="container gallery-hero-grid"><div class="gallery-hero-copy"><h1 data-campo="iti_resumo1" v-html="html(galeriaHero, 'iti_resumo1')"></h1><p data-campo="iti_descricao1" v-html="html(galeriaHero, 'iti_descricao1')"></p></div><div class="gallery-hero-media"><img v-if="image(galeriaHero)" alt="Grupo de cães e gatos da Galeria Pets" data-img="imagem" :src="image(galeriaHero)" @error="hideBrokenImage"></div></div></section>
<section class="section gallery-listing"><div class="container"><div class="gallery-toolbar" data-bloco="galeria-lista-titulo" data-tipo="conteudo"><div><span class="eyebrow" data-campo="iti_nome" v-html="html(galeriaListaTitulo, 'iti_nome')"></span><h2 data-campo="iti_referencia" v-html="html(galeriaListaTitulo, 'iti_referencia')"></h2></div><label class="pet-search"><span v-html="html(galeriaListaTitulo, 'iti_titulo')"></span><input v-model.trim="searchQuery" type="search" placeholder="Buscar nome do pet..." aria-label="Buscar pet pelo nome" data-pet-search=""></label></div><div class="pet-gallery-modern" data-bloco="galeria-lista" data-tipo="lista" data-repetidor="galeria-lista">
<figure data-item="" data-pet-name="Clara" v-for="(item, index) in paginatedGaleria" :key="index"><div class="pet-photo"><img v-if="image(item)" :alt="text(item, 'iti_nome')" data-img="imagem" :src="image(item)" @error="hideBrokenImage"><div class="pet-share"><a target="_blank" rel="noopener noreferrer" :aria-label="'Compartilhar ' + plainName(item) + ' no Facebook'" :href="facebookShareLink(item)"><i class="fa-brands fa-facebook-f" aria-hidden="true"></i></a></div></div><figcaption data-campo="iti_nome" v-html="html(item, 'iti_nome')"></figcaption></figure>
</div><p v-if="!filteredGaleria.length" class="pet-empty" v-html="html(galeriaListaTitulo, 'iti_resumo1')"></p><nav v-if="totalPages > 1" class="gallery-pagination" aria-label="Paginação da galeria"><button type="button" :disabled="currentPage === 1" aria-label="Página anterior" @click="setPage(currentPage - 1)">‹</button><button v-for="page in totalPages" :key="page" type="button" :class="{ active: currentPage === page }" :aria-current="currentPage === page ? 'page' : undefined" @click="setPage(page)">{{ page }}</button><button type="button" :disabled="currentPage === totalPages" aria-label="Próxima página" @click="setPage(currentPage + 1)">›</button></nav></div></section></main>
<a class="whatsapp" href="https://wa.me/5551991544590"><span></span></a>
</main> 
</template>

<script>
import {
  contentValue,
  firstImage,
  gridItems,
  loadScreens,
  normalizeInternalLink,
  applyPageMeta,
  plainText,
} from '@/services/contentApi';

export default {
  name: 'GaleriaView',
  data() {
    return {
      galeriaHero: {},
      galeriaListaTitulo: {},
      galeriaLista: [],
      searchQuery: '',
      currentPage: 1,
      itemsPerPage: 40,
      heroSlide: 0,
      carouselSlide: 0,
      carouselTimer: null,
    };
  },
  computed: {
    filteredGaleria() {
      const query = plainText(this.searchQuery).toLocaleLowerCase('pt-BR');
      if (!query) return this.galeriaLista;
      return this.galeriaLista.filter((item) =>
        plainText(contentValue(item, 'iti_nome')).toLocaleLowerCase('pt-BR').includes(query)
      );
    },
    totalPages() {
      return Math.ceil(this.filteredGaleria.length / this.itemsPerPage);
    },
    paginatedGaleria() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredGaleria.slice(start, start + this.itemsPerPage);
    },
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
    },
  },
  created() {
    this.loadContent();
  },
  mounted() {
    this.carouselTimer = window.setInterval(() => {
      this.nextHeroSlide();
      this.nextCarouselSlide();
    }, 5500);
  },
  beforeUnmount() {
    if (this.carouselTimer) window.clearInterval(this.carouselTimer);
  },
  methods: {
    plainName(item) {
      return plainText(contentValue(item, 'iti_nome'));
    },
    facebookShareLink(item) {
      const id = item?.itiId ?? item?.iti_id ?? this.plainName(item);
      const route = this.$router.resolve({ path: '/galeria', query: { pet: String(id) } }).href;
      const origin = typeof window === 'undefined' ? '' : window.location.origin;
      return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(origin + route);
    },
    setPage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      this.$nextTick(() => this.$el.querySelector('.gallery-listing')?.scrollIntoView({ behavior: 'smooth' }));
    },
    text(source, field, fallback = '') {
      return contentValue(source, field, fallback);
    },
    html(source, field, fallback = '') {
      return contentValue(source, field, fallback);
    },
    image(source, fallback = '') {
      return firstImage(source) || fallback;
    },
    hideBrokenImage(event) { event.currentTarget.hidden = true; },
    bg(source) {
      const url = firstImage(source);
      return url ? { backgroundImage: 'url("' + url + '")' } : {};
    },
    grids(source) {
      return gridItems(source);
    },
    link(source, field, fallback = '') {
      return normalizeInternalLink(contentValue(source, field, fallback), fallback);
    },
    applyMeta(source) {
      applyPageMeta({
        title: contentValue(source, 'iti_resumo1') || contentValue(source, 'iti_nome'),
        description: contentValue(source, 'iti_descricao1') || contentValue(source, 'iti_resumo1'),
        image: firstImage(source),
      });
    },
    nextHeroSlide() {
      const total = this.homeHero?.length || this.$el.querySelectorAll('[data-vue-carousel="hero"] > [data-slide-index]').length || 1;
      this.heroSlide = (this.heroSlide + 1) % total;
    },
    goHeroSlide(index) {
      this.heroSlide = index;
    },
    nextCarouselSlide() {
      const total = this.$el.querySelectorAll('[data-vue-carousel="content"] > [data-slide-index]').length || 1;
      this.carouselSlide = (this.carouselSlide + 1) % total;
    },
    goCarouselSlide(index) {
      this.carouselSlide = index;
    },
    async loadContent() {
      const data = await loadScreens([
        {
          ctiId: 27,
          key: "galeriaHero",
          multi: false,
        },
        {
          ctiId: 28,
          key: "galeriaListaTitulo",
          multi: false,
        },
        {
          ctiId: 29,
          key: "galeriaLista",
          multi: true,
        },
      ]);

      Object.assign(this, data);
      this.applyMeta(this.galeriaHero);
    },
  },
};
</script>

<style scoped>
.gallery-pagination {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 42px;
}
.gallery-pagination button {
  display: grid;
  place-items: center;
  min-width: 42px;
  height: 42px;
  padding: 0 12px;
  border: 1px solid #e2d5e5;
  border-radius: 999px;
  background: #fff;
  color: #65466e;
  font: inherit;
  font-weight: 900;
  cursor: pointer;
}
.gallery-pagination button.active {
  border-color: #825195;
  background: #825195;
  color: #fff;
}
.gallery-pagination button:disabled {
  cursor: default;
  opacity: .4;
}
</style>
